/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_User_Otp_ErrorInputs */

const vi_toast_user_otp_error = /** @type {(inputs: Toast_User_Otp_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không cập nhật được đăng nhập OTP`)
};

/**

* @param {Toast_User_Otp_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_user_otp_error = /** @type {((inputs?: Toast_User_Otp_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_User_Otp_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_user_otp_error(inputs)
});